<tc-grid-search-criteria
        [chipConfigKey]="chipConfigKey"
        [inputSearchCriteria]="inputSearchCriteria"
        [searchCriteriaUpdatingDataKey]="searchCriteriaUpdatingDataKey"
        [searchResultsDataKey]="searchResultsDataKey"
        [searchCriteriaLoadingDataKey]="searchCriteriaLoadingDataKey"
        [createNewSearchCriteriaFn]="createNewSearchCriteriaFn"
        [clearLoadedSearchCriteriaFn]="clearLoadedSearchCriteriaFn"
        [placeHolderText]="placeHolderText">
</tc-grid-search-criteria>
